import {mapActions, mapState} from 'vuex'

export default {
  data () {
    return {
      activeName: 'first'
    }
  },
  computed: {
    ...mapState('myRecordModule', ['couponDetailById']),
  },
  methods: {
    ...mapActions('myRecordModule', ['getCouponInfoById']),
  },
  mounted () {
    const id = this.$route.query.itemId
    let data = {
      buyId: id
    }
    this.getCouponInfoById(data)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/my-record/views/coupon-info-detail.js